import {
  Config,
  configurator,
  enumsCashback,
  ReplaceAllInstances,
  Translator,
  useClientWallet,
  useFetchApi,
  useRedirect,
} from "@itarget/shared";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReRegisterRedirect } from "../../hooks/useReRegisterRedirect";
import {
  auth as authRedux,
  offers,
  payment as paymentRedux,
  subscription,
  toast,
} from "../../redux";
import ShoppingCartView from "./views/ShoppingCartView";

const ShoppingCartContainer = () => {
  const dispatch = useDispatch();
  const cloneDeep = require("clone-deep");
  const { PRODUCTS_CAMPINGS } = enumsCashback;
  const { goTo } = useRedirect();
  const [selected, setSelected] = useState([]);
  const [total, setTotal] = useState(0);
  const [state, setState] = useState("cards");
  const [openConfirmUnsubscribe, setOpenConfirmUnsubscribe] = useState(false);
  const [currentRow, setCurrentRow] = useState();
  const [incIds, setIncIds] = useState("");
  const [vlTotal, setVlTotal] = useState();
  const [showWrongCard, setShowWrongCard] = useState(false);
  const [resetStatePayment, setResetStatePayment] = useState(false);
  const [subscriptionPayment, setSubscriptionPayment] = useState([]);
  const [activityChecked, setActivityChecked] = useState([]);
  const [amountProduct, setAmountProduct] = useState(1);
  const user = useSelector((state) => state.auth.user);
  const center_cost_id = useSelector((state) => state.auth.cc);
  const settingCommerce = useSelector((state) => state.setting.settingCommerce);
  const selectedLang = useSelector((state) => state.language.lang);
  const paymentType = useSelector((state) => state.payment.type);
  const totalState = useSelector((state) => state.payment.total);
  const [selectActivity, setSelectActivity] = useState("");
  const isAuthenticated = useSelector((state) => state.auth.isAutenticated);
  const [showQuiz, setShowQuiz] = useState();
  const [cashbackWalletBalanceUsed, setCashbackWalletBalanceUsed] = useState(0);
  const { getBalance, isBalanceLoaded } = useClientWallet();
  const [alert, setAlert] = useState({ message: "", open: false });
  const [showDialogCashback, setShowDialogCashback] = useState(false);
  const [amountToApply, setAmountToApply] = useState(0);
  const userPermissions = useSelector(
    (state) => state.fidelity.userPermissions
  );

  const handleCleanAppliedCashbackWallet = () => {
    setCashbackWalletBalanceUsed(0);
  };
  const handleApplyCashbackWallet = (amount) => {
    const isSubscriptionLinkedToVoucher = selected.filter(s => s.voucher_id !== null);
    if (isSubscriptionLinkedToVoucher.length > 0) {
       setShowDialogCashback(true);
    } else {
      const numericAmount = Number(amount);
          setCashbackWalletBalanceUsed(
            (previousAmount) => previousAmount + numericAmount
          );
    }
  };

  const handleConfirmCashback = async () => {
      const response = await fetchVoucherCancel({
        subscriptionIds: selected.map(s => parseInt(s.inscricao_uuid))
      });
      if (response) {
        const numericAmount = Number(amountToApply);
        setCashbackWalletBalanceUsed(
          (previousAmount) => previousAmount + numericAmount
        );
        await fetchInscricoes();
        dispatch(
          toast.actions.enqueue({
            content: Translator({
              transRef: "translation.Voucher cancelado com sucesso!",
            }),
            severity: "success",
          })
        );
        return;
      }      
      setShowDialogCashback(false);
      dispatch(
        toast.actions.enqueue({
          content: Translator({
            transRef: "translation.Erro ao cancelar voucher. Tente novamente.",
          }),
          severity: "error",
        })
      );
      return;
  };

  const handleCancelCashback = () => {
    setShowDialogCashback(false);
  };

  const {
    fetchData: fetchVoucherCancel,
  } = useFetchApi(
    Config.baseURLV2 + `api/subscription/persons/subscribe/voucher`,
    "DELETE",
    {
      Authorization: `Bearer ${user.access_token}`,
    }
  );

  const {
    data: inscricoesApi,
    fetchData: fetchInscricoes,
    isLoading: isLoadingSubscriptionPending,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/subscription/pending?pessoa_id=${
        user.data && user.data.id
      }&origem_inscricao=5`
  );

  const {
    data: inscricoesApiDueDate,
    isLoading: isLoadingInscricoesDueDate,
    fetchData: fetchInscricoesDueDate,
  } = useFetchApi(
    Config.baseURLV2 + `api/subscription/persons/due-date`,
    "PUT",
    {
      Authorization: `Bearer ${user.access_token}`,
    }
  );

  const { data: reRegister, fetchData: fetchReRegister } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/person/re/register?pessoa_id=${user?.data?.id}&centro_custo_id=${center_cost_id}&aplicacoes=4`
  );

  const { data: setting, fetchData: fetchSetting } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/setting?centro_custo_id=${center_cost_id}&${configurator.MY_ACTIVITY}&${configurator.DISCOUNT}&${configurator.ACTIVE_VOUCHER}`
  );

  const translation = {
    selectActivity: Translator({
      transRef: "translation.Selecione a atividade %s primeiro.",
    }),
    success: Translator({
      transRef: "translation.Pagamento efetuado com sucesso.",
    }),
  };

  const { data: questions, fetchData: fetchQuestions } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/question?centro_custo_id=${center_cost_id}&pessoa_id=${user?.data?.id}&destino_pergunta=17`
  );

  useReRegisterRedirect();

  useEffect(() => {
    if (
      userPermissions?.cashWhoCanRedeem &&
      userPermissions?.cashWhoCanRedeem?.status === 2
    ) {
      setAlert({
        message: userPermissions?.cashWhoCanRedeem?.message,
        open: true,
      });
    } else {
      setAlert({
        message: "",
        open: false,
      });
    }
  }, [userPermissions?.cashWhoCanRedeem]);

  useEffect(() => {
    if (resetStatePayment) {
      setResetStatePayment(false);
    }
  }, [resetStatePayment]);

  useEffect(() => {
    if (selected.length > 0) {
      const ids = selected.map((res, i) => {
        return res?.conta_receber_id;
      });
      setIncIds(ids.toString());
    } else {
      setTotal(0);
    }
  }, [selected]);

  useEffect(() => {
    fetchInscricoesDueDate({ origin: "shopping-cart" });
    fetchInscricoes();
    fetchQuestions();
    fetchSetting();
  }, []);

  useEffect(() => {
    if (inscricoesApi?.data) {
      async function subscriptionPending() {
        const subscriptionPending = cloneDeep(
          inscricoesApi.data.filter(
            (res) => res.controle_boleto_cartao_id === null
          )
        );
        dispatch(offers.actions.setShoppingCarts(subscriptionPending));
        const notOverdue = subscriptionPending.filter((s) => s.esta_vencido !== "S");
        setSelected((prev) => {
          const prevIds = new Set((prev || []).map((p) => p.conta_receber_id));
          const stillSelected = notOverdue.filter((s) => prevIds.has(s.conta_receber_id));
          return (prev && prev.length) ? stillSelected : notOverdue;
        });
        setSubscriptionPayment(subscriptionPending);
        setActivityChecked((prev) => {
          const allowedIds = new Set(notOverdue.map((n) => n.conta_receber_id));
          const prevList = prev || [];
          const stillChecked = prevList.filter((id) => allowedIds.has(id));
          return prevList.length ? stillChecked : Array.from(allowedIds);
        });
      }
      subscriptionPending();
    }
  }, [inscricoesApi]);

  useEffect(() => {
    if (selectActivity) {
      dispatch(
        toast.actions.enqueue({
          content: ReplaceAllInstances(
            translation.selectActivity.props.children,
            [selectActivity]
          ),
          severity: "error",
        })
      );
    }
    setSelectActivity("");
  }, [selectActivity]);

  const onChangeSelected = (e, card = {}) => {
    if (
      card.pre_agenda_atividades?.length &&
      !card.pre_agenda_atividades.every(
        (pre_agenda) =>
          activityChecked.includes(
            subscriptionPayment.find(
              (course) =>
                course.agenda_atividade_id ===
                pre_agenda.agenda_atividade_pre_id
            )?.conta_receber_id
          ) ||
          !card.pre_agenda_atividades.every((pre_atividade) =>
            subscriptionPayment.some(
              (course) =>
                course.agenda_atividade_id ===
                pre_atividade.agenda_atividade_pre_id
            )
          )
      )
    ) {
      setSelectActivity(
        card.pre_agenda_atividades.map(
          (pre_atividade) => pre_atividade.descricao
        )
      );
      return;
    }
    if (
      setting?.data
        ?.filter((s) => s.codigo === 404)
        .filter((f) => f.ativo === "S").length > 0
    ) {
      if (e.target.checked) {
        if (card.categoria_tipo_atividade === 1) {
          setSelected([
            ...selected,
            ...subscriptionPayment.filter(
              (f) => f.categoria_tipo_atividade === 1
            ),
          ]);
          setActivityChecked([...activityChecked, card.conta_receber_id]);

          if (
            subscriptionPayment.filter((f) => f.categoria_tipo_atividade === 1)
              .length > 1
          ) {
            dispatch(
              toast.actions.enqueue({
                content: setting.data.filter((s) => s.codigo === 404)[0]
                  .valor_referencia,
              })
            );
          }
        } else {
          setSelected([...selected, card]);
          setActivityChecked([...activityChecked, card.conta_receber_id]);
        }
      } else {
        if (card.categoria_tipo_atividade === 1) {
          setSelected((selected) =>
            selected.filter(
              (res) =>
                !subscriptionPayment
                  .filter((f) => f.categoria_tipo_atividade === 1)
                  .map((m) => m.agenda_atividade_id)
                  .includes(res.agenda_atividade_id)
            )
          );

          setActivityChecked((activityChecked) => {
            return activityChecked.filter(
              (d) =>
                !subscriptionPayment
                  .filter((f) => f.categoria_tipo_atividade === 1)
                  .map((c) => c.conta_receber_id)
                  .includes(d)
            );
          });
        } else {
          const dependences = subscriptionPayment
            .filter((scription) =>
              scription.pre_agenda_atividades?.some(
                (pre_agenda) =>
                  pre_agenda.agenda_atividade_pre_id ===
                  card.agenda_atividade_id
              )
            )
            .map((dep) => dep?.conta_receber_id);
          const newCheckeds = activityChecked.filter(
            (activity) =>
              !dependences.some((dep) => dep === activity) &&
              activity !== card?.conta_receber_id
          );
          setActivityChecked(newCheckeds);
          setSelected((selected) =>
            selected.filter(
              (res) => res.conta_receber_id !== card.conta_receber_id
            )
          );
        }
      }
    } else {
      if (e.target.checked) {
        setSelected([...selected, card]);
        setActivityChecked([...activityChecked, card.conta_receber_id]);
      } else {
        const dependences = subscriptionPayment
          .filter((scription) =>
            scription.pre_agenda_atividades?.some(
              (pre_agenda) =>
                pre_agenda.agenda_atividade_pre_id === card.agenda_atividade_id
            )
          )
          .map((dep) => dep.conta_receber_id);
        const newCheckeds = activityChecked.filter(
          (activity) =>
            !dependences.some((dep) => dep === activity) &&
            activity !== card.conta_receber_id
        );
        setActivityChecked(newCheckeds);
        setSelected((selected) =>
          selected.filter(
            (res) =>
              !dependences.some((dep) => dep === res.conta_receber_id) &&
              res.conta_receber_id !== card.conta_receber_id
          )
        );
      }
    }
    handleCleanAppliedCashbackWallet();
  };

  const onClickUnsubscribe = () => {
    dispatch({
      type: "FETCH_STARTED",
      meta: {
        actions: subscription.actions.SUBSCRIPTION,
        body: JSON.stringify({
          id: currentRow.inscricao_uuid,
        }),
        url: Config.baseURL + `api/${selectedLang}/subscription/unsubscribe`,
        method: "PUT",
      },
    });

    dispatch(
      offers.actions.setShoppingCarts(
        subscriptionPayment.filter(
          (row) => row.inscricao_uuid !== currentRow.inscricao_uuid
        )
      )
    );
    setSubscriptionPayment(
      subscriptionPayment.filter(
        (row) => row.inscricao_uuid !== currentRow.inscricao_uuid
      )
    );
    setSelected((selected) =>
      selected.filter((res) => res.inscricao_uuid !== currentRow.inscricao_uuid)
    );
    handleCloseUnsubscribe();
  };

  const goFinish = () => {
    goTo("my-activity");
  };

  const handleCloseUnsubscribe = () => {
    setOpenConfirmUnsubscribe(false);
  };

  const openModal = (row) => {
    setOpenConfirmUnsubscribe(true);
    setCurrentRow(row);
  };

  const onInvalidCardPayment = () => {
    setShowWrongCard(true);
  };

  const changePayment = () => {
    setResetStatePayment(true);
    setShowWrongCard(false);
  };

  const amountProductChange = (value) => {
    setAmountProduct(value);
  };

  useEffect(() => {
    if (
      questions &&
      questions?.data?.length > 0 &&
      !questions?.data[0]?.respondido
    ) {
      setShowQuiz(true);
    }
  }, [questions]);

  const isLoading = isLoadingSubscriptionPending;

  const pendingWithCashbackRedemption = () => {
    let array = [];
    array = selected.filter(
      (pendingRow) =>
        pendingRow.pagar_com_cashback ===
        PRODUCTS_CAMPINGS.PAY_WITH_CASHBACK.ALLOWED
    );

    return array;
  };
  const getLimitCashbackRedemption = () => {
    let limit = 0;
    const rows = pendingWithCashbackRedemption();
    const sumRowLimit = (row) => {
      const value = Number(row.cr_valor);
      const percentageLimit = Number(row.percentual_cashback);
      const rowLimit = (value * percentageLimit) / 100;
      limit += rowLimit;
    };
    rows.forEach(sumRowLimit);
    return limit;
  };

  const cashbackWalletLimitRedemption = getLimitCashbackRedemption();
  const userBalance = getBalance();
  const cashbackBalance = userBalance.cashbackBalance;
  const canUseCashbackWallet =
    !!pendingWithCashbackRedemption().length &&
    !!cashbackBalance &&
    state === "cards";

  return (
    <ShoppingCartView
      alert={alert}
      isLoading={isLoading}
      activityChecked={activityChecked}
      vlTotal={vlTotal}
      goFinish={goFinish}
      openModal={openModal}
      openConfirmUnsubscribe={openConfirmUnsubscribe}
      handleCloseUnsubscribe={handleCloseUnsubscribe}
      onClickUnsubscribe={onClickUnsubscribe}
      center_cost_id={center_cost_id}
      toast={toast}
      paymentRedux={paymentRedux}
      paymentType={paymentType}
      totalState={totalState}
      fetchInscricoes={fetchInscricoes}
      subscriptionState={selected}
      state={state}
      setState={setState}
      courses={subscriptionPayment}
      selected={selected}
      setSelected={setSelected}
      total={total}
      subscription={subscription}
      user={user}
      showWrongCard={showWrongCard}
      resetStatePayment={resetStatePayment}
      onChangeSelected={onChangeSelected}
      onInvalidCardPayment={onInvalidCardPayment}
      setShowWrongCard={setShowWrongCard}
      changePayment={changePayment}
      setting={setting}
      settingCommerce={settingCommerce}
      dispatch={dispatch}
      amountProduct={amountProduct}
      amountProductChange={amountProductChange}
      goTo={goTo}
      showQuiz={showQuiz}
      setShowQuiz={setShowQuiz}
      authRedux={authRedux}
      cashbackWalletBalanceUsed={cashbackWalletBalanceUsed}
      handleApplyCashbackWallet={handleApplyCashbackWallet}
      handleCleanAppliedCashbackWallet={handleCleanAppliedCashbackWallet}
      canUseCashbackWallet={canUseCashbackWallet}
      cashbackWalletLimitRedemption={cashbackWalletLimitRedemption}
      userCashbackBalance={cashbackBalance}
      isBalanceLoaded={isBalanceLoaded}
      cashbackSymbol={userBalance.symbol}
      showDialogCashback={showDialogCashback}
      handleConfirmCashback={handleConfirmCashback}
      handleCancelCashback={handleCancelCashback}
    />
  );
};

export default ShoppingCartContainer;
